<template>
	<section class="main-content contentblocks">
		<div v-for="block in contentblocks" :key="block.ID" class="contentblock fade-animate up">
			<div class="row">
				<div class="columns column6 contentblock-content">
					<div class="title-reverse-wrapper">
						<h2>{{ block.header }}</h2>
						<h3 class="subtitle">{{ block.subtitle }}</h3>
					</div>
					<div v-parse-links v-html="block.content" />
					<HotelsForTreesWidget v-if="block.ID == 24" />
				</div>
				<div class="contentblock-image">
					<picture>
						<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
						<source :srcset="block.image" />
						<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
					</picture>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblock {
	margin: 40px auto;
	position: relative;

	.row {
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;
		align-items: center;
	}

	&:nth-child(even) {
		.row {
			flex-flow: row-reverse wrap;
		}
	}

	:deep(.button) {
		background: none;
		border-radius: 100px;
		padding: 10px 30px;

		&:hover {
			background: var(--body-color);
			color: #fff;
		}
	}

	h2 {
		line-height: 1.2em;
	}
}

.background-dark {
	h2,
	h3 {
		color: #fff;
	}
}

.row-header {
	max-width: 1000px;
}

.contentblock-image {
	width: 42%;
}

.contentblock-content {
	margin: 60px 0;
	position: relative;
	z-index: 2;
	width: 50%;
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 10px;
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
	}

	.contentblock {
		.row {
			flex-flow: column-reverse wrap !important;
		}
	}

	.contentblock-content {
		width: 100%;
		margin: 0 auto;
		padding: 50px 20px;
	}
}
</style>
